var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_c('div',{staticClass:"txt"},[_vm._v("提交成功")])])}
var staticRenderFns = []

export { render, staticRenderFns }